import React from 'react'

export default function PersonDetails({ data, tabChanged}) {
  const Item = (item) => {
    return <div className='person-profile-body-item'>
      <div className='person-profile-item-header'>
        {item.attribute}
      </div>
      <div className='person-profile-item-body'>
        {item.value}
      </div>
    </div>
  }
  return (
    <>
      <div className='person-profile-header'>
        <span className='mr-2'>
          <i className='far fa-user'></i>
        </span>
        Person Details
      </div>
      <div className='person-profile-body'>
        <Item attribute='First Name' value={data && data?.firstName !== null ? data.firstName : '-'} />
        <Item attribute='Last Name' value={data && data?.lastName !== null ? data.lastName : '-'} />
        <Item attribute='Email' value={data && data?.email !== null ? data.email : '-'} />
        <Item attribute='Phone Number' value={data && data?.phone !== null ? data.phone : '-'} />
        <Item attribute='Email Marketing' value={data && data?.emailMarketing == "Active" ? "Subscribed" : "UnSubscribed"} />
        <a
        id='profileTabLink'
          onClick={() => {
            tabChanged({ name: 'Profile', id: 'PROFILE_TAB', status: '' });
          }}
        //  className={`nav-link ${currentStatus}`}
        style={{
            color: '#007bff',
            margin: '4px 12px',
            padding: '20px 0px',
            display: 'block',
            fontSize: '17px'

        }}
          href={'#PROFILE_TAB'}
          role='tab'
          data-toggle='tab'
          key={'PROFILE_TAB'}
        > Edit Profile</a>
      </div>
    </>

  )
}
